"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InputTypes = exports.FORMAT_MAP = void 0;
var _moment2 = _interopRequireDefault(require("moment"));
var _ibanFormatter = _interopRequireDefault(require("./ibanFormatter"));
var _currencyFormatter = _interopRequireDefault(require("./currencyFormatter"));
var InputTypes = exports.InputTypes = {
  currency: 'currency',
  iban: 'iban',
  date: 'date',
  datetime: 'datetime',
  timestamp: 'timestamp',
  jsondate: 'jsondate',
  number: 'number',
  moment: 'moment'
};
var FORMAT_MAP = exports.FORMAT_MAP = {
  DATE: 'DD/MM/YYYY',
  DATETIME: 'DD/MM/YYYY HH:mm:ss',
  TIME: 'HH:mm:ss'
};
var excelExportFormatter = {
  currency: function currency(_ref) {
    var value = _ref.value,
      currencyType = _ref.currencyType,
      currencyPrecision = _ref.currencyPrecision,
      allowEmpty = _ref.allowEmpty,
      removeTrailingZeros = _ref.removeTrailingZeros;
    return allowEmpty && value === '' ? value : _currencyFormatter.default.format(value, currencyType, currencyPrecision, removeTrailingZeros).trim();
  },
  number: function number(value) {
    if (!value) return null;
    return String(value);
  },
  iban: function iban(value) {
    if (value && value.length === 26) {
      var formattedValue = (0, _ibanFormatter.default)(value);
      if (!formattedValue) return null;
      return formattedValue;
    }
    return value;
  },
  date: function date(value) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FORMAT_MAP.DATE;
    if (!value) {
      return null;
    }
    var date;
    if (typeof value === 'string' && value.endsWith('Z')) {
      date = (0, _moment2.default)(value);
    } else {
      date = (0, _moment2.default)(value, 'DD-MM-YYYY');
    }
    return date.format(format).toString();
  },
  jsondate: function jsondate(value) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FORMAT_MAP.DATETIME;
    if (!value) {
      return null;
    }
    var date = (0, _moment2.default)(value);
    return date.format(format).toString();
  },
  timestamp: function timestamp(value) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FORMAT_MAP.DATETIME;
    if (!value || isNaN(value) || value <= 0) {
      return null;
    }
    var date = (0, _moment2.default)(new Date(value * 1000));
    return date.format(format).toString();
  },
  time: function time(value) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FORMAT_MAP.TIME;
    if (!value) {
      return null;
    }
    var date = (0, _moment2.default)(value, 'HH:mm:ss');
    return date.format(format).toString();
  },
  moment: function moment(value) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FORMAT_MAP.DATE;
    if (!value) {
      return null;
    }
    var isMoment = _moment2.default.isMoment(value);
    if (isMoment) return value.format(format).toString();
    // eslint-disable-next-line no-unused-expressions
    else null;
  }
};
var _default = exports.default = excelExportFormatter;